/* eslint-disable no-restricted-syntax */
export function lowerCaseKeys<T>(object: { [key: string]: T }): { [key: string]: T } {
  const result: { [key: string]: T } = {};

  for (const [key, value] of Object.entries(object)) {
    result[key[0].toLowerCase() + key.slice(1)] = value;
  }

  return result;
}
